import { Fragment, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { t } from "i18next";

import { selectUser, setAccessToken } from "@/app/auth/auth.slice";
import { ProfileListModal } from "../organisms/ProfileListModal";
import { useOtherProfilesQuery } from "@/app/auth/auth.api";
import { Permission } from "@/shared/hooks/usePermission";
import Navbar from "@/shared/components/organisms/Navbar";
import { ROLE_NAMES } from "../organisms/BranchSideBar";

const navigation = [
  {
    name: "KPIs",
    href: "/kpis",
    permission: Permission.ACCESS_KPI,
    roles: [
      ROLE_NAMES.SUPER_ADMIN,
      ROLE_NAMES.COMMERCIAL,
      ROLE_NAMES.ADMIN,
      ROLE_NAMES.COACH,
      ROLE_NAMES.TRAINER_PERSONAL,
      ROLE_NAMES.RECEPTIONIST,
    ],
  },
  {
    name: t("gym.views.gyms"),
    href: "/gyms",
    permission: Permission.COMPANY_ACCESS,
    roles: [ROLE_NAMES.SUPER_ADMIN, ROLE_NAMES.MANAGER],
  },
  {
    name: t("branch.views.branchs"),
    href: "/branchs",
    permission: Permission.BRANCH_ACCESS_ALL_BRANCHES,
    roles: [
      ROLE_NAMES.SUPER_ADMIN,
      ROLE_NAMES.MANAGER,
      ROLE_NAMES.COMMERCIAL,
      ROLE_NAMES.COACH,
      ROLE_NAMES.RECEPTIONIST,
      ROLE_NAMES.ADMIN,
    ],
  },
  {
    name: t("user.views.users"),
    href: "/users",
    permission: Permission.USERS_ACCESS,
    roles: [
      ROLE_NAMES.SUPER_ADMIN,
      ROLE_NAMES.MANAGER,
      ROLE_NAMES.COMMERCIAL,
      ROLE_NAMES.ADMIN,
      ROLE_NAMES.COACH,
      ROLE_NAMES.TRAINER_PERSONAL,
      ROLE_NAMES.RECEPTIONIST,
    ],
  },
  {
    name: t("ticket.views.loyalty_assistant_2"),
    href: "/assigned",
    permission: Permission.LOYALTY_VIEW_COMPLETED_TASKS,
    roles: [
      ROLE_NAMES.SUPER_ADMIN,
      ROLE_NAMES.COMMERCIAL,
      ROLE_NAMES.ADMIN,
      ROLE_NAMES.COACH,
      ROLE_NAMES.TRAINER_PERSONAL,
      ROLE_NAMES.RECEPTIONIST,
    ],
  },
  {
    name: "Accesos",
    href: "/access",
    permission: Permission.ACCESS_KPI,
    roles: [
      ROLE_NAMES.SUPER_ADMIN,
      ROLE_NAMES.MANAGER,
      ROLE_NAMES.ADMIN,
      ROLE_NAMES.COACH,
      ROLE_NAMES.TRAINER_PERSONAL,
      ROLE_NAMES.RECEPTIONIST,
    ],
  },
];

export const RootLayout = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const otherProfilesQuery = useOtherProfilesQuery(undefined);
  const [profileListVisible, setProfileListVisible] = useState(false);

  const updatedNavigation = useMemo(() => {
    if (!user || !user.role) {
      return [];
    }

    return navigation
      .filter((item) => item.roles.includes(user.role))
      .map((item) => ({
        ...item,
        current: item.href === location.pathname,
      }));
  }, [user, location.pathname]);

  return (
    <Fragment>
      <div className="flex flex-col h-screen w-screen">
        <Navbar
          navigation={updatedNavigation}
          user={user}
          onChangeProfile={() => setProfileListVisible(true)}
        />
        <div className="flex flex-col h-0 flex-1">
          <Outlet />
        </div>
      </div>
      <ProfileListModal
        visible={profileListVisible}
        setVisible={setProfileListVisible}
        profiles={otherProfilesQuery.data ?? []}
        onSelectProfile={(profile) => {
          localStorage.setItem("accessToken", profile.accessToken);
          dispatch(setAccessToken({ accessToken: profile.accessToken }));
          setProfileListVisible(false);
        }}
      />
    </Fragment>
  );
};
